exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "label[data-v-3629a9d0] {\n  margin-bottom: 0;\n}\n.header-line-bot[data-v-3629a9d0] {\n  border-bottom: 1px solid #212529;\n}", ""]);

// exports
